// utils/trackingPixels/track.ts - utils/trackingPixels.ts split (sub-module track)

import type {AnalyticsEventCategory} from './types.js';
import type {AnalyticsEventType} from './types.js';
import type {TrackingEventData} from './types.js';
import { getSessionId } from './dedupe.js';
import { isDuplicateEvent } from './dedupe.js';


export async function trackAnalyticsEvent(
    eventType: AnalyticsEventType,
    eventCategory: AnalyticsEventCategory,
    userIdentifier: string | null,
    data: {
        formId?: string;
        productId?: string;
        orderId?: string;
        brandId?: string;
        advertiserId?: string;
        eventData?: TrackingEventData;
    }
) {
    try {
        if (isDuplicateEvent(eventType, data)) return;
        // Dynamic import: supabase-js (±165KB) jangan ikut entry publik — event
        // analytics dikirim setelah load, jadi muat client saat benar-benar kirim.
        const { supabase } = await import('../../supabase/client');
        const sessionId = getSessionId();
        const effectiveUserId = userIdentifier || sessionId;
        const { error } = await (supabase
            .from('analytics_events')
            .insert({
                event_type: eventType,
                event_category: eventCategory,
                user_identifier: effectiveUserId,
                session_id: sessionId,
                form_id: data.formId,
                product_id: data.productId,
                order_id: data.orderId,
                brand_id: data.brandId,
                advertiser_id: data.advertiserId,
                event_data: { pageUrl: window.location.href, referrer: document.referrer, ...data.eventData }
            }) as any);
        if (error) {
            if (error.code === '409' || (error as any)?.status === 409 || (error as any)?.code === '23505' || (error as any)?.code === '23503') { }
            else console.error('[Analytics] Error tracking event:', error);
        } else console.log(`[Analytics] Event tracked: ${eventType}`);
    } catch (err) { console.error('[Analytics] Error in trackAnalyticsEvent:', err); }
}
